import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import DriverLayout from "@/components/DriverLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import Inventory from "@/pages/Inventory";
import Fleet from "@/pages/Fleet";
import POS from "@/pages/POS";
import Financial from "@/pages/Financial";
import Suppliers from "@/pages/Suppliers";
import Employees from "@/pages/Employees";
import Safety from "@/pages/Safety";
import Reports from "@/pages/Reports";
import Assistant from "@/pages/Assistant";
import DailyBalance from "@/pages/DailyBalance";
import DriverPortal from "@/pages/DriverPortal";

const ADMIN_ROUTES = [
  ["/", Dashboard], ["/customers", Customers], ["/inventory", Inventory],
  ["/fleet", Fleet], ["/pos", POS], ["/financial", Financial],
  ["/suppliers", Suppliers], ["/employees", Employees], ["/safety", Safety], ["/reports", Reports],
  ["/daily-balance", DailyBalance], ["/assistant", Assistant],
];

function Routed() {
  const { user } = useAuth();
  if (user === null)
    return <div className="h-screen flex items-center justify-center text-muted-foreground">Loading...</div>;

  const isDriver = user && user.role === "driver";

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {user === false ? (
        <Route path="*" element={<Navigate to="/login" replace />} />
      ) : isDriver ? (
        <>
          <Route path="/" element={<DriverLayout><DriverPortal /></DriverLayout>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </>
      ) : (
        <>
          {ADMIN_ROUTES.map(([path, C]) => (
            <Route key={path} path={path} element={<Layout><C /></Layout>} />
          ))}
          <Route path="*" element={<Navigate to="/" replace />} />
        </>
      )}
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <AuthProvider>
        <BrowserRouter>
          <Routed />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
